/**
 * Step types for RMC order intake workflow
 */

/**
 * Step types enum for RMC order intake wizard
 */
export enum RmcOrderIntakeStepType {
  QUOTE = 'QUOTE',
  MATERIAL = 'MATERIAL',
  MIX_CHARACTERISTICS = 'MIX_CHARACTERISTICS',
  QUANTITY = 'QUANTITY',
  USAGE = 'USAGE',
  UNLOADING_METHOD = 'UNLOADING_METHOD',
  INTERVALS = 'INTERVALS',
  DATE = 'DATE',
  TIME = 'TIME',
  DETAILS = 'DETAILS'
}
